import * as React from 'react';

export default function CardFigureLine() {
	return (
		<svg
			className="m-card__figure-line"
			xmlns="http://www.w3.org/2000/svg"
			role="presentation"
			viewBox="904 -507 320 115"
			preserveAspectRatio="none"
		>
			<g
				stroke="none"
				strokeWidth="1"
				fill="none"
				fillRule="evenodd"
				transform="translate(904.000000, -507.000000)"
			>
				<polygon className="m-card__polygon--left" points="0 36.0150376 320 115.600741 320 115 0 115" />
				<polygon className="m-card__polygon--right" points="0 102.459265 320 0.697443618 320 115 0 115" />
				<polygon
					className="m-card__polygon--top"
					points="0 101.541627 117.265896 65 320 114.788912 320 115 0 115"
				/>
			</g>
		</svg>
	);
}
